
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import TerminReservierungNeuLogic from "@/logic/bestellung_neu/termin_reservierung_neu_logic"
import { VerfuegbarkeitUhrzeit } from "mangdto/dist/common/verfuegbarkeit"
import Formatter from "@/logic/formatter"
import { LoadState } from "mangdto"

@Component({ components: { FilialeHeader, NichtGueltig } })
export default class TerminReservierungNeu extends mixins(Calculator) {
  logic: TerminReservierungNeuLogic = null

  LoadState = LoadState

  dateMenuVisible: boolean = false
  timeDialogVisible: boolean = false
  personen: number[] = Array.from({ length: 10 }, (_, i) => i + 1)

  get bestaetigenEnabled() {
    return this.logic.derSlot != null
  }

  formatiereSlot(slot: VerfuegbarkeitUhrzeit) {
    return (
      Formatter.formatiereUhrzeit(slot.uhrzeitVon) +
      " - " +
      Formatter.formatiereUhrzeit(slot.uhrzeitBis)
    )
  }

  saveSelectedDate(selectedDate) {
    ;(this.$refs as any).dateMenu.save(selectedDate)
  }

  reloadDates(val) {
    this.logic.pickerMonth = val
  }

  allowedDates(val) {
    let result = false
    this.logic.allowedDates.forEach((toCompare) => {
      if (toCompare.datum === val) {
        result = true
      }
    })
    return result
  }

  terminBestaetigen() {
    this.logic.terminBestaetigen()
  }

  mounted() {
    this.logic = new TerminReservierungNeuLogic()
    this.logic.init()
  }
}
